import {
  CREATE_SALES_ORDER,
  CREATE_SALES_ORDER_SUCCESS,
  CREATE_SALES_ORDER_FAILURE,
  POSTCODE_LOOKUP,
  POSTCODE_LOOKUP_SUCCESS,
  POSTCODE_LOOKUP_FAILURE,
  GET_RENDER_ECOMMERCE_STORE,
  GET_RENDER_ECOMMERCE_STORE_SUCCESS,
  GET_RENDER_ECOMMERCE_STORE_FAILURE,
  GET_PRODUCT_CATEGORIES,
  GET_PRODUCT_CATEGORIES_SUCCESS,
  GET_PRODUCT_CATEGORIES_FAILURE,
  SEARCH_PRODUCTS_CATEGORY,
  SEARCH_PRODUCTS_CATEGORY_SUCCESS,
  SEARCH_PRODUCTS_CATEGORY_FAILURE,
  CALCULATE_SHIPPING,
  CALCULATE_SHIPPING_SUCCESS,
  CALCULATE_SHIPPING_FAILURE,
  CALCULATE_ORDER_TOTAL,
  CALCULATE_ORDER_TOTAL_SUCCESS,
  CALCULATE_ORDER_TOTAL_FAILURE,
  EXECUTE_ECOMMERCE_STORE,
  EXECUTE_ECOMMERCE_STORE_SUCCESS,
  EXECUTE_ECOMMERCE_STORE_FAILURE,
  GET_ECOMMERCE_DELIVERY_SLOTS,
  GET_ECOMMERCE_DELIVERY_SLOTS_SUCCESS,
  GET_ECOMMERCE_DELIVERY_SLOTS_FAILURE,
} from "./actionType";

//CREATE_SALES_ORDER
export const createSalesOrder = (data) => ({
  type: CREATE_SALES_ORDER,
  payload: data,
});
export const createSalesOrderSuccess = (response) => ({
  type: CREATE_SALES_ORDER_SUCCESS,
  payload: response,
});
export const createSalesOrderFailure = (error) => ({
  type: CREATE_SALES_ORDER_FAILURE,
  payload: error,
});
///extpostcodelookup/search
export const postcodeLookup = (data) => ({
  type: POSTCODE_LOOKUP,
  payload: data,
});
export const postcodeLookupSuccess = (response) => ({
  type: POSTCODE_LOOKUP_SUCCESS,
  payload: response,
});
export const postcodeLookupFailure = (error) => ({
  type: POSTCODE_LOOKUP_FAILURE,
  payload: error,
});
///ecommercestore/render/
export const getRenderEcommerceStore = (data) => ({
  type: GET_RENDER_ECOMMERCE_STORE,
  payload: data,
});
export const getRenderEcommerceStoreSuccess = (response) => ({
  type: GET_RENDER_ECOMMERCE_STORE_SUCCESS,
  payload: response,
});
export const getRenderEcommerceStoreFailure = (error) => ({
  type: GET_RENDER_ECOMMERCE_STORE_FAILURE,
  payload: error,
});
///ecommercestoreproductcategory/public/listwithproduct/
export const getProductCategories = (data) => ({
  type: GET_PRODUCT_CATEGORIES,
  payload: data,
});
export const getProductCategoriesSuccess = (response) => ({
  type: GET_PRODUCT_CATEGORIES_SUCCESS,
  payload: response,
});
export const getProductCategoriesFailure = (error) => ({
  type: GET_PRODUCT_CATEGORIES_FAILURE,
  payload: error,
});
///ecommercestoreproductcategorytoproduct/public/search/
export const searchProductsByCategory = (data) => ({
  type: SEARCH_PRODUCTS_CATEGORY,
  payload: data,
});
export const searchProductsByCategorySuccess = (response) => ({
  type: SEARCH_PRODUCTS_CATEGORY_SUCCESS,
  payload: response,
});
export const searchProductsByCategoryFailure = (error) => ({
  type: SEARCH_PRODUCTS_CATEGORY_FAILURE,
  payload: error,
});
///ecommercestore/public/calculate/shipping/
export const calculateShipping = (data, urlExtension) => ({
  type: CALCULATE_SHIPPING,
  payload: data,
  urlExtension: urlExtension,
});
export const calculateShippingSuccess = (response) => ({
  type: CALCULATE_SHIPPING_SUCCESS,
  payload: response,
});
export const calculateShippingFailure = (error) => ({
  type: CALCULATE_SHIPPING_FAILURE,
  payload: error,
});
///ecommercestore/public/calculate/ordertotal/
export const calculateOrderTotal = (data, urlExtension) => ({
  type: CALCULATE_ORDER_TOTAL,
  payload: data,
  urlExtension: urlExtension,
});
export const calculateOrderTotalSuccess = (response) => ({
  type: CALCULATE_ORDER_TOTAL_SUCCESS,
  payload: response,
});
export const calculateOrderTotalFailure = (error) => ({
  type: CALCULATE_ORDER_TOTAL_FAILURE,
  payload: error,
});
///ecommercestore/public/execute/
export const executeEcommerceStore = (data, urlExtension) => ({
  type: EXECUTE_ECOMMERCE_STORE,
  payload: data,
  urlExtension: urlExtension,
});
export const executeEcommerceStoreSuccess = (response) => ({
  type: EXECUTE_ECOMMERCE_STORE_SUCCESS,
  payload: response,
});
export const executeEcommerceStoreFailure = (error) => ({
  type: EXECUTE_ECOMMERCE_STORE_FAILURE,
  payload: error,
});
///ecommercestoredeliveryslot/public/list/  — pass { id: <GlobalEcommerceStore_IdExternal> }
export const getEcommerceDeliverySlots = (data) => ({
  type: GET_ECOMMERCE_DELIVERY_SLOTS,
  payload: data,
});
export const getEcommerceDeliverySlotsSuccess = (response) => ({
  type: GET_ECOMMERCE_DELIVERY_SLOTS_SUCCESS,
  payload: response,
});
export const getEcommerceDeliverySlotsFailure = (error) => ({
  type: GET_ECOMMERCE_DELIVERY_SLOTS_FAILURE,
  payload: error,
});
